function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.36)",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "m28.264 998.07c-9.509 0-17.201 7.3419-17.201 16.405 0 0.1469 9.3e-4 4.121 0 7.891h4.4647c-1.81e-4 -3.2303 0-6.4987 0-6.6104 0-7.4537 5.7057-13.498 12.736-13.498 7.0307 0 12.736 6.0442 12.736 13.498 0 0.1117-0.0016 3.3801 0 6.6104h4.4647c-7.56e-4 -3.77 0-7.7441 0-7.891 0-9.0632-7.6921-16.405-17.201-16.405z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.9895 1022.4h36.548c0.61356 0 1.1075 0.495 1.1075 1.1099v25.527c0 0.6148-0.49395 1.1099-1.1075 1.1099h-36.548c-0.61356 0-1.1075-0.4951-1.1075-1.1099v-25.527c0-0.6149 0.49395-1.1099 1.1075-1.1099z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.264 1027.9c-2.1408 0-3.8763 1.7391-3.8763 3.8845 0 1.5531 0.90052 2.8815 2.215 3.503-3.77e-4 0.012 0 0.022 0 0.034v4.7863c0 0.6149 0.49395 1.1099 1.1075 1.1099h1.1075c0.61356 0 1.1075-0.495 1.1075-1.1099v-4.7863c0-0.012 3.76e-4 -0.023 0-0.034 1.3145-0.6215 2.215-1.9499 2.215-3.503 0-2.1454-1.7355-3.8845-3.8763-3.8845z",
  fill: "none"
}));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lock.89b6207f.svg";
export { ForwardRef as ReactComponent };